import { render } from "./HomeIcon.vue?vue&type=template&id=6d63a67a"
const script = {}

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__